export default function (item, buttonName) {
  return true
}
